import { createContext, useEffect, useState } from "react";
import { getProfileApi, logoutApi } from "../api/auth.api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const login = async () => {
    await fetchProfile();
  };

  const logout = async () => {
    await logoutApi();
    setUser(null);
    setPermissions([]);
  };

  const fetchProfile = async () => {
    try {
      const res = await getProfileApi();
      setUser(res.data.data.user);
      const userPermissions =
        res.data.data.user.roles?.flatMap((r) => r.permissions) || [];
      setPermissions([...new Set(userPermissions)]);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        permissions,
        loading,
        login,
        logout,
        fetchProfile,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
